import { useState } from 'react';

export type SwapStep = 'idle' | 'approving' | 'swapping';

export const useFormState = () => {
  const [swapStep, setSwapStep] = useState<SwapStep>('idle');
  const [swapAmount, setSwapAmount] = useState('');
  const [lastSwappedAmount, setLastSwappedAmount] = useState('');
  const [isMaxHovered, setIsMaxHovered] = useState(false);
  const [isApproveHovered, setIsApproveHovered] = useState(false);
  const [isSwapHovered, setIsSwapHovered] = useState(false);

  // Reset form for a new swap
  const resetForm = () => {
    setSwapAmount('');
    setSwapStep('idle');
  };

  // Store last swapped amount before resetting
  const saveLastSwappedAmount = (amount: string) => {
    setLastSwappedAmount(amount);
  };

  return {
    swapStep,
    swapAmount,
    lastSwappedAmount,
    isMaxHovered,
    isApproveHovered,
    isSwapHovered,
    setSwapStep,
    setSwapAmount,
    setLastSwappedAmount: saveLastSwappedAmount,
    setIsMaxHovered,
    setIsApproveHovered,
    setIsSwapHovered,
    resetForm,
  };
};
